export const MOCK_MONASH_OBJECT_ID = '0000aaaa-bbbb-cccc-dddd-eeeeeeeeeeee';
